import React, { useState, useEffect } from "react";

export const Context = React.createContext("");
export const ContextProvider = ({ children }) => {
  const [current, setCurrent] = useState(window.location.pathname);

  useEffect(() => {
    if (current === "/ourServices/prodRed") {
      document.body.setAttribute("class", "black");
    } else {
      document.body.setAttribute("class", "blue");
    }
  }, [current]);
  return (
    <Context.Provider value={{ current, setCurrent }}>
      {children}
    </Context.Provider>
  );
};
